import type { RootState } from '@core/core/store'
import { createSelector } from '@reduxjs/toolkit'

import { mapFetchingAdapter } from './mapFetchingSlice'

const selectSelf = (state: RootState) => state.mapFetching
export const { selectById: selectMapFetchingResultByProjectId } =
  mapFetchingAdapter.getSelectors(selectSelf)

export const selectMapFetchingState = createSelector([selectSelf], mapFetching => {
  return {
    status: mapFetching.status,
    error: mapFetching.error,
  }
})
